module.exports = __webpack_public_path__ + "static/media/metamask.901f9c75.png";